"use strict";
var SUCCESS_ONE_KEY = "successMessageOne";
var SUCCESS_MULTIPLE_KEY = "successMessageMultiple";
var MESSAGE_KEY = "assignedPrograms";
;
var AssignProgramsController = (function () {
    /* @ngInject */
    function AssignProgramsController($route, groupsService, $location, userSessionService, $rootScope, messagingService, typeaheadProviderService) {
        var _this = this;
        this.$route = $route;
        this.groupsService = groupsService;
        this.$location = $location;
        this.userSessionService = userSessionService;
        this.$rootScope = $rootScope;
        this.messagingService = messagingService;
        this.typeaheadProviderService = typeaheadProviderService;
        this.assignPrograms = [];
        this.assignGroups = [];
        this.assignInstructors = [];
        this.programTypeaheadPaths = ["courseSlug", "courseTitle"];
        this.groupTypeaheadPaths = ["groupName", "groupCode"];
        this.instructorTypeaheadPaths = ["name.firstName", "name.lastName", "name.displayName"];
        this.assignmentTypes = {
            assignGroups: this.assignGroups,
            assignInstructors: this.assignInstructors,
            assignPrograms: this.assignPrograms
        };
        this.handleAdd = function (tag, type) {
            _this.tagType = _this.typeaheadProviderService.setTagType(type, _this.assignmentTypes);
            _this.tagType.push(tag);
        };
        this.handleRemove = function (tag, type) {
            _this.tagType = _this.typeaheadProviderService.setTagType(type, _this.assignmentTypes);
            _this.tagType.splice(_this.tagType.indexOf(tag), 1);
        };
        this.errorCallback = function () {
            _this.$rootScope.loadingError = true;
            _this.$rootScope.loadingView = false;
        };
        this.goHome = function () {
            if (_this.userSessionService.isDistrictMode()) {
                _this.$location.path("/" + _this.userSessionService.getDistrictTenantId());
            }
            else {
                _this.$location.path("/" + _this.tenantId);
            }
        };
        this.typeaheadProvider = function (input, typeaheadSource, tags, typeaheadPaths) {
            return _this.typeaheadProviderService.typeaheadProvider(input, typeaheadSource, tags, typeaheadPaths);
        };
        this.handleResponse = function (status) {
            if (status < 400) {
                if (_this.assignGroups.length === 1) {
                    _this.$rootScope.successMessage = _this.assignGroups.length + " " + _this.messagingService(MESSAGE_KEY)[SUCCESS_ONE_KEY];
                }
                else {
                    _this.$rootScope.successMessage = _this.assignGroups.length + " " + _this.messagingService(MESSAGE_KEY)[SUCCESS_MULTIPLE_KEY];
                }
                _this.goHome();
            }
            else {
                _this.errorCallback();
            }
        };
    }
    AssignProgramsController.prototype.$onInit = function () {
        var locals = this.$route.current.locals;
        this.tenantId = this.$route.current.params.tenantId;
        this.groups = locals.groups;
        this.studyPrograms = locals.studyPrograms;
        this.instructors = locals.instructors;
        this.updateCrumbs();
    };
    AssignProgramsController.prototype.submitReady = function () {
        return !!this.assignPrograms.length && !!this.assignGroups.length && !!this.assignInstructors.length;
    };
    AssignProgramsController.prototype.submit = function () {
        this.clearError();
        this.$rootScope.loadingView = true;
        var properties = {
            instructors: this.assignInstructors,
            studyPrograms: this.assignPrograms,
            groups: this.assignGroups
        };
        this.groupsService.assignGroups(this.tenantId, properties)
            .then(this.handleResponse, this.errorCallback);
    };
    AssignProgramsController.prototype.clearError = function () { this.$rootScope.loadingError = false; };
    AssignProgramsController.prototype.updateCrumbs = function () {
        if (this.userSessionService.isDistrictMode()) {
            this.crumbs = [
                {
                    name: "Naviance Test Prep: District",
                    url: "" + this.userSessionService.getDistrictTenantId()
                },
                {
                    name: "" + this.userSessionService.getCurrentSchool().name,
                    url: "" + this.userSessionService.getDistrictTenantId()
                },
                {
                    name: "Assign Study Programs"
                }
            ];
        }
        else {
            this.crumbs = [
                {
                    name: "Naviance Test Prep",
                    url: "" + this.tenantId
                }, {
                    name: "Assign Study Programs"
                }
            ];
        }
    };
    return AssignProgramsController;
}());
exports.AssignProgramsController = AssignProgramsController;



/** WEBPACK FOOTER **
 ** ./app/assign-programs/assign-programs.controller.ts
 **/